import CHAINS from "lib/chains";
import { Chain } from "./types";

const chainIdMap = new Map<number, Chain>();

for (let key of Object.keys(CHAINS)) {
  chainIdMap.set(CHAINS[key as Chain]?.chainId, key as Chain);
}

export default chainIdMap;
